var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.getLoad)?_c('div',{staticClass:"wraped"},[_c('div',{staticClass:"load"},[_c('v-progress-circular',{attrs:{"size":"50","indeterminate":"","color":"primary"}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }